export default __webpack_public_path__ + "static/media/busable-logo-1.f133a68e.svg";